import { render, staticRenderFns } from "./Sbprocessing.vue?vue&type=template&id=246257a5&"
import script from "./Sbprocessing.vue?vue&type=script&lang=js&"
export * from "./Sbprocessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports